import { getLanguages, getTranslate } from 'react-localize-redux'

export const selectTranslate = state => getTranslate(state.locale)
export const selectLanguages = state => getLanguages(state.locale)
